import { ChunkSize, TileSize, SpriteSize } from './size'
import { PlayerZLevel } from './layer'

export const Constants = {
  TileSize,
  SpriteSize,
  ChunkSize,
  PlayerZLevel,
}
